import ProductDescription from './ProductDescription'

const CannedFishProduct = {
  ...ProductDescription,
  category: '08',
  subCategory: '',
  IsBroadband: true,
  FishType: '',
  PackedIn: '',
}

export default CannedFishProduct
